<template>
    <div style="display: contents">
        <div class="cursor" id="cursor"></div>
        <router-view/>
    </div>
</template>

<script>
import MobileDetect from "mobile-detect";
export default {
    name: "App",
    mixins: [],
    components: {},
    provide() {
        return {}
    },
    props: {},
    data() {
        return {

        }
    },
    created() {

        let md = new MobileDetect(window.navigator.userAgent);
        console.log(md.mobile())
        if (md.mobile() !== null) {
            //추후 추가
            // location.href = "http://m.hamalab.io";
        }
    },
    mounted() {
    },
    beforeUnmount() {
    },
    unmounted() {
    },
    computed: {},
    methods: {},
    watch: {},
}
</script>

<style lang="scss">
@import "./assets/scss/index.scss";

</style>
